export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const PAYMENT_WITH_CARD = 'PAYMENT_WITH_CARD'
export const PAYMENT_WITH_CARDSAVE = 'PAYMENT_WITH_CARDSAVE'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const ADD_USER_CARD = 'ADD_USER_CARD'
export const GET_USER_CARD = 'GET_USER_CARD'
export const DELETE_USER_CARD = 'DELETE_USER_CARD'
